import {
  formatRuleLabelsSearchText,
  formatRuleTargetSearchText,
} from './ruleTableDisplay';
import type { AutoAssignmentRule } from './rulesApi';

export type RulesTableRow = AutoAssignmentRule & {
  target: string;
  labelsSummary: string;
};

export const toRulesTableRow = (rule: AutoAssignmentRule): RulesTableRow => ({
  ...rule,
  target: formatRuleTargetSearchText(rule.filter),
  labelsSummary: formatRuleLabelsSearchText(rule.labels),
});
